import FormField from './FormField';
import FormWrapper from './FormWrapper';
import CredentialSecurityNotice from './CredentialSecurityNotice';
import type { FieldConfig } from './types';

const fields: FieldConfig[] = [
    {
        name: 'endpoint',
        label: 'FHIR Endpoint',
        type: 'url',
        required: true,
        placeholder: 'https://fhir.epic.com/...',
        extra: 'Example: https://fhir.epic.com/interconnect-fhir-oauth/api/FHIR/R4',
    },
    {
        name: 'clientId',
        label: 'Client ID',
        type: 'text',
        required: true,
        placeholder: 'Enter Epic client ID',
        isCredential: true,
    },
    {
        name: 'privateKey',
        label: 'Private Key',
        type: 'textarea',
        required: true,
        placeholder: '-----BEGIN PRIVATE KEY-----\n...\n-----END PRIVATE KEY-----',
        extra: 'JWT private key for authentication',
        rows: 4,
        isCredential: true,
    },
    {
        name: 'organization',
        label: 'Organization ID',
        type: 'text',
        required: true,
        placeholder: 'Enter Epic organization ID',
    },
];

export default function EpicConfigForm() {
    return (
        <FormWrapper>
            <CredentialSecurityNotice />
            {fields.map(field => (
                <FormField
                    key={Array.isArray(field.name) ? field.name.join('.') : field.name}
                    config={field}
                />
            ))}
        </FormWrapper>
    );
}
